import { List, Map, Record } from "immutable";

export const fromJSON = (json: Partial<IOneLookLocationData>): OneLookLocationRecord => {
  const recordData: IOneLookLocationRecord = { ...(json as any) };

  recordData.create = Map<string, string>(json.create || {});
  recordData.products = List(Object.entries(json.products || {}).map(([name]) => name));

  return new OneLookLocationRecord(recordData);
};

export interface IOneLookLocationData {
  code: string;
  name: string;
  create: { [key: string]: string };
  products: { [key: string]: number };
}

export interface IOneLookLocationRecord {
  code: string;
  name: string;
  create: Map<string, string>;
  products: List<string>;
}

export const defaultOneLookLocationProps: IOneLookLocationRecord = {
  code: "",
  name: "",
  create: Map<string, string>(),
  products: List<string>(),
};

export class OneLookLocationRecord extends Record(defaultOneLookLocationProps) implements IOneLookLocationRecord {}
